export default __webpack_public_path__ + "static/psgCard5-f4877b852f156d10a0e9579c267319bd.webp";